export const mutations = {
  set_token(state, token) {
    state.token = token;
    sessionStorage['site_current_token'] = token;
  },
  set_userid(state, userid) {
    state.userid = userid;
    localStorage['site_current_userid'] = userid;
  },
  set_appid(state, appid) {
    state.app_id = appid;
    localStorage['site_current_app_id'] = appid;
  },
  retry_count_add(state) {
    state.retry_count++;
  },
  set_login_go(state, path) {
    state.after_login_go = path;
    localStorage['site_current_login_go'] = path;
  },
  set_nickname(state, nickname) {
    state.wx_info.nickname = nickname;
    localStorage['wx_nickname'] = nickname;
  },
  set_headimgurl(state, headimgurl) {
    state.wx_info.headimgurl = headimgurl;
    localStorage['wx_headimgurl'] = headimgurl;
  },
  set_openid(state, openid) {
    state.wx_info.openid = openid;
    localStorage['wx_openid'] = openid;
  },
  set_username(state, username) {
    state.wx_info.username = username;
    localStorage['wx_username'] = username;
  },
  set_mobile(state, mobile) {
    state.wx_info.mobile = mobile;
    localStorage['wx_mobile'] = mobile;
  },
  set_vehicleState(state, vehicleState) {
    state.vehicleState = vehicleState;
    localStorage['vehicleState'] = vehicleState;
  },
  set_yhcgbazt(state, yhcgbazt) {
    state.yhcgbazt = yhcgbazt;
    localStorage['yhcgbazt'] = yhcgbazt;
  },
  set_yhctbazt(state, yhctbazt) {
    state.yhctbazt = yhctbazt;
    localStorage['yhctbazt'] = yhctbazt;
  },
  set_yhjsybazt(state, yhjsybazt) {
    state.yhjsybazt = yhjsybazt;
    localStorage['yhjsybazt'] = yhjsybazt;
  },
  set_yhyyybazt(state, yhyyybazt) {
    state.yhyyybazt = yhyyybazt;
    localStorage['yhyyybazt'] = yhyyybazt;
  },
  set_slot(state, slot) {
    state.slot = slot;
    localStorage['slot'] = slot;
  },
  set_showMineTab(state, showMineTab) {
    state.showMineTab = showMineTab;
    localStorage['showMineTab'] = String(showMineTab);
  },
  set_aiChatVehicleBound(state, value) {
    state.aiChatVehicleBound = value;
    localStorage['aiChatVehicleBound'] = String(value);
  },
  set_thyySelectedContent(state, thyySelectedContent) {
    state.thyySelectedContent = thyySelectedContent;
  },
  // 设置遮罩层
  set_isLoading(state, isLoading) {
    state.isLoading = isLoading;
  },
  // 设置用户是否为第一次登陆
  set_firstTime(state) {
    state.isFirstTime = false
  },
  // set_firstTimeOpen(state) {
  //   state.isFirstTime = true
  // }
};
